import getData from '../functions/getData';

/* eslint-disable */
const defaultTexts = {
    headlineText: 'Diese Website verwendet Cookies',
    sublineText: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend zu verbessern, verwenden wir Cookies.',
    submitButtonText: 'Auswahl bestätigen',
    submitAllButtonText: 'Alle auswählen',
    consentTypes: {
        marketing: {
            label: 'Marketing',
            title: 'Marketing-Cookies',
            text: 'Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind und daher wertvoller für Publisher und werbetreibende Drittparteien sind.',
        },
        necessary: {
            label: 'Notwendig',
            title: 'Notwendige Cookies',
            text: 'Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.',
        },
        preferences: {
            label: 'Präferenzen',
            title: 'Präferenz-Cookies',
            text: 'Präferenz-Cookies ermöglichen einer Webseite sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie sich befinden.',
        },
        statistics: {
            label: 'Statistiken',
            title: 'Statistik-Cookies',
            text: 'Statistik-Cookies helfen Webseiten-Besitzer*innen zu verstehen, wie Besucher*innen mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
        },
    },
    showDetailsText: 'Details anzeigen',
    hideDetailsText: 'Details ausblenden',
    moreInfoPreText: 'Weitere Informationen zu Cookies finden Sie in unserer',
    moreInfoLinkText: 'Datenschutzerklärung',
    cookieConsentHref: '/datenschutz',
}

export default {
    headlineText: getData('data-cookie-consent-headline', defaultTexts.headlineText),
    sublineText: getData('data-cookie-consent-subline', defaultTexts.sublineText),
    submitButtonText: getData('data-cookie-consent-submit', defaultTexts.submitButtonText),
    submitAllButtonText: getData('data-cookie-consent-submit-all', defaultTexts.submitAllButtonText),
    consentTypes: {
        marketing: {
            label: getData('data-cookie-consent-marketing-label', defaultTexts.consentTypes.marketing.label),
            title: getData('data-cookie-consent-marketing-title', defaultTexts.consentTypes.marketing.title),
            text: getData('data-cookie-consent-marketing-text', defaultTexts.consentTypes.marketing.text),
        },
        necessary: {
            label: getData('data-cookie-consent-necessary-label', defaultTexts.consentTypes.necessary.label),
            title: getData('data-cookie-consent-necessary-title', defaultTexts.consentTypes.necessary.title),
            text: getData('data-cookie-consent-necessary-text', defaultTexts.consentTypes.necessary.text),
        },
        preferences: {
            label: getData('data-cookie-consent-preferences-label', defaultTexts.consentTypes.preferences.label),
            title: getData('data-cookie-consent-preferences-title', defaultTexts.consentTypes.preferences.title),
            text: getData('data-cookie-consent-preferences-text', defaultTexts.consentTypes.preferences.text),
        },
        statistics: {
            label: getData('data-cookie-consent-statistics-label', defaultTexts.consentTypes.statistics.label),
            title: getData('data-cookie-consent-statistics-title', defaultTexts.consentTypes.statistics.title),
            text: getData('data-cookie-consent-statistics-text', defaultTexts.consentTypes.statistics.text),
        }
    },
    showDetailsText: getData('data-cookie-consent-show-details', defaultTexts.showDetailsText),
    hideDetailsText: getData('data-cookie-consent-hide-details', defaultTexts.hideDetailsText),
    moreInfoPreText: getData('data-cookie-consent-more-info-pretext', defaultTexts.moreInfoPreText),
    moreInfoLinkText: getData('data-cookie-consent-more-info-linktext', defaultTexts.moreInfoLinkText),
    cookieConsentHref: getData('data-cookie-consent-href', defaultTexts.cookieConsentHref),
}
